<template>
    <v-sheet v-if="ieoClient.length > 0" class="classIEOCARD my-3" color="transparent" :height="height" :width="width">
        <HexagonMinComponent 
        class="HexagonPosition Hexagon2"
        :title="ieoDistri"
        :color="'red'"
        :subtitle="t('labels.online')"
        :size-hexa="sizeHexa"
        :size-title="sizeTitl"
        :size-sub-ti="sizeSubt"
        />
        <HexagonMinComponent 
        class="HexagonPosition Hexagon1"
        :title="ieoAcceso"
        :color="'red'"
        :subtitle="t('labels.online')"
        :size-hexa="sizeHexa"
        :size-title="sizeTitl"
        :size-sub-ti="sizeSubt"
        /> 
        <HexagonMinComponent 
        class="HexagonPosition Hexagon3"
        :title="ieoClient"
        :color="'red'"
        :subtitle="t('labels.online')"
        :size-hexa="sizeHexa"
        :size-title="sizeTitl"
        :size-sub-ti="sizeSubt"
        /> 

        <v-sheet class="cardTitleIEO IEO1">
            <span> {{ t('labels.distribution') }} </span>
        </v-sheet>

        <v-sheet class="cardTitleIEO IEO2">
            <span> {{ t('labels.access') }}  </span>
        </v-sheet>

        <v-sheet class="cardTitleIEO IEO3">
            <span> {{ t('labels.client') }} </span>
        </v-sheet>
    </v-sheet>
</template>

<script setup lang="ts">
import { ref, computed} from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import HexagonMinComponent  from '@/components/principalPage/hexagonMinComponent.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';    
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

defineProps({
    width       : { type: Number, default: 300 },
    height      : { type: Number, default: 200 }
})

const sizeHexa      = ref(105);
const sizeTitl      = ref(35);
const sizeSubt      = ref(13);

const ieoDistri     = computed(() => store.state.ieoDistri);
const ieoAcceso     = computed(() => store.state.ieoAcceso);
const ieoClient     = computed(() => store.state.ieoClient);

</script>

<style>
.classIEOCARD{
    position: relative;
}
.classIEOCARD .cardTitleIEO{
    position: absolute;
    text-align: center; 
    align-content: center;
    border-radius: 5px;
    width: 120px;
    height: 30px;
    background-color: rgba(72,73,91,1);
}
.classIEOCARD .HexagonPosition{
    position: absolute;
    z-index: 2;
}
.Hexagon1{
    left: 30%;
    top: 25%;
}
.Hexagon2{
    left: 60%;
    top: 0%;
}
.Hexagon3{
    left: 59%;
    top: 54%;
}

.IEO1{
    top: 5%;
    left: 28%;
}
.IEO3{
    width: 160px !important;
    top: 85%;
    left: 15%;
}
.IEO2{
    top: 45%;
    left: 0%;
}
</style>